import { Typography } from '@mui/material';
import React from 'react';

export type SecurityMessageProps = {
  message?: string;
  className?: string;
};

/**
 * Security Message Component
 * Displays the security message in the header with responsive behavior
 */
const SecurityMessage = ({
  message = 'La seguridad "Empieza conmigo y continúa con nosotros"',
  className
}: SecurityMessageProps) => {
  return (
    <Typography
      component="h2"
      variant="caption"
      className={className}
      sx={{
        color: 'rgb(75, 85, 99, 1)',
        fontStyle: 'italic',
        fontSize: '1em',
        fontWeight: 'light',
        ml: 2,
        flexGrow: 1,
        display: { xs: 'none', sm: 'block' }
      }}
    >
      {message}
    </Typography>
  );
};

export default SecurityMessage;
